<div
  class="flex-container nes-mb-10 nes-flex nes-flex-col-reverse xl:nes-flex-row nes-justify-between nes-bg-active-inverse nes-rounded-container nes-w-full"
>
  <div class="nes-w-full xl:nes-w-6/12 nes-p-8 nes-text-default">
    <h2 class="nes-font-bold nes-text-1000 nes-mb-5">
      {{ "ADVICE.BUSINESS_CASE.HEADER" | translate }}
    </h2>
    <p class="nes-mb-3">
      {{ "ADVICE.BUSINESS_CASE.TEXT" | translate }}
    </p>
    <p class="nes-mb-5">
      {{ "ADVICE.BUSINESS_CASE.HELP" | translate }}
    </p>
    <div class="flex-container nes-flex nes-flex-col xl:nes-flex-row nes-gap-5">
      <nes-button variant="brand" (nesOnClick)="shareAdviceLink.emit()">{{
        "ADVICE.BUSINESS_CASE.BUTTON.DOWNLOAD" | translate
      }}</nes-button>
      <nes-button variant="primary" (nesOnClick)="requestContact.emit()">{{
        "ADVICE.BUSINESS_CASE.BUTTON.CONTACT" | translate
      }}</nes-button>
    </div>
  </div>
  <div class="nes-w-full xl:nes-w-6/12">
    <img
      src="assets/images/business_case.png"
      alt="systeemoverzicht"
      [ngClass]="isMobileView ? 'pic_mobile' : 'pic_desktop'"
    />
  </div>
</div>
